import React from 'react';
import { Switch, Route } from 'react-router-dom';
import TackBoardContainer from '../containers/tack_board/index';
import TackNotificationDetailsContainer from '../containers/tack_notification_details';

export default class TackBoard extends React.Component {
  render() {
    return(
      <Switch>
        <Route path="/tack_board/:wordText/notification/:slug" component={ TackNotificationDetailsContainer } />
        <Route path="/tack_board/notification/:slug" component={ TackNotificationDetailsContainer } />
        <Route path="/tack_board/:tab" component={ TackBoardContainer } />
        <Route path="/tack_board" component={ TackBoardContainer } />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/tack_board.jsx